/**
 * Pure decision for same-origin in-app HTML link interception.
 * Used by the leave guard before offering save-and-exit.
 */
export function shouldInterceptHtmlNavigation(
  current: Pick<URL, "origin" | "pathname">,
  target: Pick<URL, "origin" | "pathname">,
): boolean {
  if (target.origin !== current.origin) {
    return false;
  }

  if (!target.pathname.endsWith(".html")) {
    return false;
  }

  return target.pathname !== current.pathname;
}
